import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    Button,
    Container,
    Grid,
    Paper,
    Typography,
} from "@material-ui/core";
import Config from "Config";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomRadioGroup from "../../inputComponent/CustomRadioGroup/CustomRadioGroup";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getUserRole } from "../../redux/selector";
import { send } from "../../SendRequest";
function SystemMessage() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userRole = useSelector(getUserRole());
    const [saveOpen, setSaveOpen] = useState(false);
    const [saveMessage, setSaveMessage] = useState("");

    const isAdmin = userRole === "SA";

    const validationSchema = yup.object().shape({
        messageEn: yup
            .string()
            .required(t("errorMsg.required"))
            .max(1000, t("errorMsg.maxTextLength", { max: 1000 })),
        messageTc: yup
            .string()
            .required(t("errorMsg.required"))
            .max(1000, t("errorMsg.maxTextLength", { max: 1000 })),
        messageSc: yup
            .string()
            .required(t("errorMsg.required"))
            .max(1000, t("errorMsg.maxTextLength", { max: 1000 })),
        status: yup.string().required(t("errorMsg.required")),
    });

    const {
        control,
        register,
        handleSubmit,
        formState,
        setValue,
        watch,
        reset,
        trigger,
    } = useForm({
        defaultValues: {
            messageEn: "",
            messageTc: "",
            messageSc: "",
            status: "",
        },
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });

    const { errors } = formState;

    useEffect(() => {
        if (isAdmin) {
            fetchSystemMessage();
        }
    }, [isAdmin]);

    const handleAlertDialogClose = () => {
        setSaveMessage("");
        setSaveOpen(false);
    };

    const fetchSystemMessage = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/settings/getNotifLoginMsgSettings`,
        };

        dispatch(send("GET_SYSTEM_MESSAGE", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    reset({
                        messageEn: result.data.messageEn || "",
                        messageTc: result.data.messageTc || "",
                        messageSc: result.data.messageSc || "",
                        status: result.data.status || "",
                    });
                }
            })
            .catch((error) => {
                console.log("fetch system message error: ", error);
            });
    };

    const saveSystemMessage = (data) => {
        const saveData = {
            messageEn: data.messageEn,
            messageTc: data.messageTc,
            messageSc: data.messageSc,
            status: data.status || "", // 确保status不会是null
        };

        const option = {
            url: `${Config.CONTENT_PATH}/settings/saveNotifLoginMsgSettings`,
            method: "POST",
            body: JSON.stringify(saveData),
        };

        dispatch(send("SAVE_SYSTEM_MESSAGE", option))
            .then((response) => response.json())
            .then((result) => {
                if (result?.success === true) {
                    reset({
                        messageEn: result.data.messageEn || "",
                        messageTc: result.data.messageTc || "",
                        messageSc: result.data.messageSc || "",
                        status: result.data.status || "",
                    });
                    setSaveOpen(true);
                    setSaveMessage(t("common.portal.savedSuccessfully"));
                } else {
                    setSaveOpen(true);
                    setSaveMessage(t("common.portal.savedFail"));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onSubmit = (data) => {
        saveSystemMessage(data);
    };

    if (!isAdmin) {
        return (
            <Container maxWidth="md">
                <Header
                    headerTitle={t("common.sideNavList.systemMessage")}
                    className="header"
                ></Header>
                <Box className="container">
                    <PortalNavbar aside className="drawer" />
                    <Box className="main" style={{ paddingLeft: "10px" }}>
                        <Typography variant="h6" component="h1">
                            {t("common.accessDenied")}
                        </Typography>
                        <Typography variant="body1">
                            {t("common.accessDeniedMessage")}
                        </Typography>
                    </Box>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.systemMessage")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <Box className="main" style={{ paddingLeft: "10px" }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Typography
                            variant="h6"
                            component="h1"
                            style={{ marginBottom: "20px" }}
                        >
                            {t("common.sideNavList.systemMessage")}
                        </Typography>

                        <Paper
                            style={{ padding: "20px", marginBottom: "20px" }}
                        >
                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <CustomTextField
                                    label={t("common.portal.enNotifLoginMsg")}
                                    id="messageEn"
                                    inputProps={{
                                        ...register("messageEn"),
                                    }}
                                    error={errors?.messageEn}
                                    multiline
                                    rows={4}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <CustomTextField
                                    label={t("common.portal.tcNotifLoginMsg")}
                                    id="messageTc"
                                    inputProps={{
                                        ...register("messageTc"),
                                    }}
                                    error={errors?.messageTc}
                                    multiline
                                    rows={4}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <CustomTextField
                                    label={t("common.portal.scNotifLoginMsg")}
                                    id="messageSc"
                                    inputProps={{
                                        ...register("messageSc"),
                                    }}
                                    error={errors?.messageSc}
                                    multiline
                                    rows={4}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: "10px" }}>
                                <CustomRadioGroup
                                    control={control}
                                    id="addFormName.status"
                                    label={t("common.portal.status")}
                                    name="status"
                                    row
                                    options={{
                                        active: t("common.portal.active"),
                                        inactive: t("common.portal.inactive"),
                                    }}
                                />
                            </Grid>

                            <Box
                                my={2}
                                display="flex"
                                justifyContent="flex-end"
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    {t("common.button.save")}
                                </Button>
                            </Box>
                        </Paper>
                    </form>
                    <AlertDialog
                        formOpen={saveOpen}
                        content={saveMessage}
                        confirmButton={{
                            action: () => handleAlertDialogClose(false),
                            label: t("common.save.failPopup.confirm"),
                        }}
                    />
                </Box>
            </Box>
        </Container>
    );
}

export default SystemMessage;
